import menuModalRoutes from 'menus/routes/modal';
import cartModalRoutes from 'cart/routes/modal';

const modalRoutes = [...cartModalRoutes, ...menuModalRoutes];

export default modalRoutes;
